import type { StatusBarProps } from "expo-status-bar"
import { StatusBar } from "expo-status-bar"

import { useIsFocused } from "@react-navigation/native"
import { useIsDarkMode } from "@/theme"

export function FocusTrackingStatusBar(props: {
  style?: StatusBarProps["style"]
}) {
  const isDark = useIsDarkMode()
  const isFocused = useIsFocused()
  if (isFocused) {
    let style = props.style
    if (!style) {
      if (isDark) {
        style = "light"
      } else {
        style = "dark"
      }
    }

    return <StatusBar style={style} />
  }
  return null
}
